// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwPanel from 'viewmodel/AwPanelViewModel';
import DesEditTeamMainPanel from 'viewmodel/DesEditTeamMainPanelViewModel';
import DesEditTeamSubPanel from 'viewmodel/DesEditTeamSubPanelViewModel';
import { ShowWhen } from 'js/hocCollection';
const DesEditTeamMainPanelShowWhen = ShowWhen(DesEditTeamMainPanel);
const DesEditTeamSubPanelShowWhen = ShowWhen(DesEditTeamSubPanel);
DesEditTeamMainPanelShowWhen.displayName = 'DesEditTeamMainPanelShowWhen';
DesEditTeamSubPanelShowWhen.displayName = 'DesEditTeamSubPanelShowWhen';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/DesTeamMembersService', () => import('js/DesTeamMembersService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "lifecycleHooks": {
    "onUnmount": "resetActiveView",
    "onUpdate": {
      "observers": ["props.accsessionid", "props.collaborationspaceid"]
    }
  },
  "data": {
    "sharedData": {
      "initialValues": {
        "activeView": "editTeamMainPanel",
        "panelView": "editTeamMainPanel",
        "existingMembers": true
      },
      "meta": {}
    }
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "teamid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    }
  },
  "actions": {
    "backAction": {
      "actionType": "JSFunction",
      "method": "backActionEditTeam",
      "inputData": {
        "sharedData": "{{data.sharedData}}"
      },
      "outputData": {
        "sharedData": ""
      },
      "deps": "js/DesTeamMembersService"
    },
    "resetActiveView": {
      "actionType": "JSFunction",
      "method": "resetPanelEditTeam",
      "inputData": {
        "sharedData": "{{data.sharedData}}"
      },
      "outputData": {
        "sharedData": ""
      },
      "deps": "js/DesTeamMembersService"
    }
  },
  "conditions": {},
  "onEvent": [{
    "eventId": "backButtonClicked",
    "action": "backAction"
  }],
  "messages": {},
  "i18n": {},
  "_viewModelId": "DesCollabEditTeam",
  "_uniqueViewModelId": "DesCollabEditTeam",
  "ctx": {}
};

/*
<aw-panel>
    <des-edit-team-main-panel show-when="data.sharedData.activeView === 'editTeamMainPanel'"
        sub-panel-context='{sharedData:data.sharedData}' accsessionid={{props.accsessionid}}
        collaborationspaceid={{props.collaborationspaceid}} teamid="{{props.teamid}}">
    </des-edit-team-main-panel>
    <des-edit-team-sub-panel show-when="data.sharedData.activeView === 'editTeamSubPanel'"
        sub-panel-context='{sharedData:data.sharedData}' accsessionid={{props.accsessionid}}
        collaborationspaceid={{props.collaborationspaceid}}>
    </des-edit-team-sub-panel>
</aw-panel>
*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement(AwPanel, {
    revealAction: actions.reveal
  }, /*#__PURE__*/React.createElement(DesEditTeamMainPanelShowWhen, {
    subPanelContext: AwParseService.instance("{sharedData:fields.sharedData}")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    accsessionid: AwParseService.instance("props.accsessionid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    collaborationspaceid: AwParseService.instance("props.collaborationspaceid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    teamid: AwParseService.instance("props.teamid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    showWhen: AwParseService.instance("fields.sharedData.activeView === 'editTeamMainPanel'")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }), /*#__PURE__*/React.createElement(DesEditTeamSubPanelShowWhen, {
    subPanelContext: AwParseService.instance("{sharedData:fields.sharedData}")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    accsessionid: AwParseService.instance("props.accsessionid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    collaborationspaceid: AwParseService.instance("props.collaborationspaceid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    showWhen: AwParseService.instance("fields.sharedData.activeView === 'editTeamSubPanel'")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;